export function removeLeadingHashtagFromNavigationHashIfNeeded(hash) {
    if (hash.startsWith('#')) {
        return hash.split('#')[1];
    }
    return hash;
}
